import { checkName } from "@services/level0Resource";
import { useMutation } from "@tanstack/react-query";

export const useValidateLevel0ResourceName = (
  options: Record<string, any> = {}
) => {
  return useMutation(checkName, options);
};
